import { View, Heading, Text, Divider, Flex, Card, Link } from "@aws-amplify/ui-react";
import Button from "react-bootstrap/Button";
import { MAPPLE_COM_LINKS,TERMS_OF_VIEWER,TERMS_OF_USE_PATH } from "../../constants/Constant";

const MarketingView = ({ onCheckout, loading }) => (
  <View padding="0.5rem">

    {/* 1. 機能紹介セクション */}
    <View marginBottom="1.5rem">
      <Heading level={6} marginBottom="0.8rem">サブスクリプションで利用できる機能</Heading>
      <View as="ul" paddingLeft="1.5rem">
        <Text as="li" marginBottom="0.5rem">
          <strong>地図印刷機能（PDFダウンロード）</strong>: 表示している地図の中心から、指定したPDFの用紙サイズに収まる範囲をファイルとして出力します。
        </Text>
        <Text as="li" marginBottom="0.5rem">
          <strong>画像作成機能</strong>: 地図上で選択した範囲をPNGファイルとして出力します。任意のサイズで画像を作成できます。
        </Text>
        <Text as="li" marginBottom="0.5rem">
          <strong>図形入力機能</strong>: 地図上に、線や面のデータを入力できます。描画内容は印刷・画像に反映されます。
        </Text>
        <Text textAlign="center" marginTop="1rem">
          <Link href={MAPPLE_COM_LINKS.SUBSCRIPTION_NEWS} isExternal={true} fontWeight="bold">
            サブスクリプションの詳細説明（別ウィンドウで開きます）
          </Link>
        </Text>
      </View>
      <View padding="0.8rem" backgroundColor="#fffbe6" borderRadius="4px" border="1px solid #ffe58f">
        {/* タイトル：行間と下部余白を詰め */}
        <Text fontSize="0.85rem" fontWeight="bold" marginBottom="0.4rem" lineHeight="1.3">
          【印刷・画像利用の許諾範囲】
        </Text>

        {/* 導入文：行間を1.4に設定 */}
        <Text fontSize="0.85rem" marginBottom="0.3rem" lineHeight="1.4">
          本サービスで作成したPDFファイルおよび画像ファイルは、以下の用途にご利用いただけます。
        </Text>

        {/* リスト：上下の余白と項目間の隙間を圧縮 */}
        <View as="ul" paddingLeft="1.2rem" marginBottom="0.4rem">
          <Text as="li" fontSize="0.85rem" marginBottom="0.2rem" lineHeight="1.4">
            <strong>個人利用の場合</strong>：私的使用の範囲内での印刷・画像利用
          </Text>
          <Text as="li" fontSize="0.85rem" marginBottom="0" lineHeight="1.4">
            <strong>法人・団体の場合</strong>：同一部署内での印刷物の共有・利用
          </Text>
        </View>

        {/* 補足文：改行による隙間を意識して調整 */}
        <Text fontSize="0.85rem" lineHeight="1.4">
          上記範囲を超える利用（所属部署外での利用、商用公開等）は、別途「複製利用許諾契約」の締結が必要となります。ご希望の場合は
          <Link
            href={MAPPLE_COM_LINKS.CONTACT_SITE}
            isExternal={true}
            color="#007bff"
            fontWeight="bold"
            margin="0 0.2rem"
          >
            お問い合わせフォーム
          </Link>
          よりご相談ください。
        </Text>
      </View>
    </View>

    <Divider orientation="horizontal" marginBottom="1.5rem" />

    {/* 2. 料金・お支払いセクション */}
    <View marginBottom="1.5rem">
      <Card variation="outlined" padding="1rem" backgroundColor="#f9f9f9">
        <Heading level={6} marginBottom="0.5rem">ご利用料金</Heading>
        <Flex direction="row" alignItems="baseline" gap="0.5rem">
          <Text fontSize="1.8rem" fontWeight="bold" color="#007bff">2,200円</Text>
          <Text fontSize="0.9rem" variation="tertiary">（税込 / 月額）</Text>
        </Flex>
        <Text fontSize="0.85rem" marginTop="0.5rem" color="font.secondary">
          ※本体価格 2,000円 + 消費税 200円<br />
          ※お申し込み日が毎月の決済日となります。
        </Text>
      </Card>
    </View>

    {/* 3. 許諾条件・注意事項セクション */}
    <View marginBottom="1rem">
      <Heading level={6} marginBottom="0.8rem">ご利用上の注意事項・許諾条件</Heading>
      <View padding="0.5rem">
        <div style={{ display: 'flex', fontSize: '0.85rem', marginBottom: '0.5rem', lineHeight: '1.5' }}>
          <strong style={{ whiteSpace: 'nowrap' }}>解約について：</strong>
          <span>いつでも解約受付ができ、解約受付後は当該利用期間終了まで機能をご利用いただけます。日割りでのご返金には対応しておりません。</span>
        </div>
        <Text fontSize="0.85rem" marginBottom="0.5rem">
          <strong>お支払い：</strong>オンライン決済「Stripe」を使用し、クレジットカードによる自動更新となります。
        </Text>
        <Text fontSize="0.85rem" marginBottom="0.5rem">
          <strong>別料金：</strong>不動産登記情報（土地）のご購入には、別途1件あたり770円（税込）が必要です。
        </Text>
        <Text fontSize="0.85rem" marginBottom="0.5rem">
          <strong>3D表示について：</strong>3D都市モデルの地形の印刷、および画像出力には対応しておりません。
        </Text>
        <div style={{ display: 'flex', fontSize: '0.85rem', lineHeight: '1.5' }}>
          <strong style={{ whiteSpace: 'nowrap' }}>サポート対応：</strong>
          <span>
            お問い合わせへの回答は、平日 10:00〜17:00 とさせていただいております。<br />
            （土・日・祝日、年末年始、および当社指定の休業日を除きます。）
          </span>
        </div>
      </View>
    </View>

    <Divider orientation="horizontal" marginBottom="1.5rem" />

    {/* 4. 利用規約確認セクション */}
    <View marginBottom="2rem">
      <Heading level={6} marginBottom="0.8rem">利用規約の確認</Heading>
      <Text fontSize="0.85rem" marginBottom="1rem" color="font.secondary">お申し込みの前に、必ず以下の規約をご確認ください。</Text>

      {/* 以前の要望通り、iframeの背景を非常に薄いグレーに設定 */}
      <View
        padding="1rem"
        backgroundColor="#fafafa"
        borderRadius="4px"
        border="1px solid #e0e0e0"
      >
        <Text fontSize="0.85rem" fontWeight="bold" marginBottom="0.5rem">【利用規約】</Text>
        <iframe
          src={TERMS_OF_VIEWER}
          className="w-100 border border-1"
          height="250"
          title="Viewer Terms"
          style={{ marginBottom: '1.5rem', backgroundColor: '#ffffff' }}
        ></iframe>

        <Text fontSize="0.85rem" fontWeight="bold" marginBottom="0.5rem">【アカウント利用規約】</Text>
        <iframe
          src={TERMS_OF_USE_PATH}
          className="w-100 border border-1"
          height="250"
          title="Account Terms"
          style={{ backgroundColor: '#ffffff' }}
        ></iframe>
      </View>
    </View>

    {/* 5. アクションセクション */}
    <View borderTop="1px solid #ddd" paddingTop="1.5rem">
      <div className="d-grid gap-2">
        <Button
          variant="primary"
          size="lg"
          onClick={onCheckout}
          disabled={loading}
          style={{ padding: '1rem', fontWeight: 'bold' }}
        >
          {loading ? "準備中..." : "月額 2,200円でサブスクリプションを開始する"}
        </Button>
      </div>
      <Text marginTop="1rem" fontSize="0.75rem" textAlign="center" color="font.tertiary">
        ボタンを押すとStripe社の決済ページへ遷移します。
      </Text>
    </View>

  </View>
);

export default MarketingView;